import { WorkspaceUsersSettings } from '@/Workspaces/Settings/WorkspaceUsersSettings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/$workspaceId/settings/users')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WorkspaceUsersSettings />
}
